import { Card, CardContent, Container, Stack, Typography } from '@mui/material';

import { TopupIcon, TopupStatus } from './topup_icon';

export type TopupResultCardProps = {
  topupStatus: TopupStatus;
};

export const TopupResultCard = ({ topupStatus }: TopupResultCardProps) => (
  <Container maxWidth="sm" sx={{ py: 4 }}>
    <Stack alignItems="center">
      <Card sx={{ width: '100%' }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Stack spacing={4} alignItems="center">
            <TopupIcon topupStatus={topupStatus} />
            <Stack spacing={2} alignItems="center">
              <Typography sx={{ fontSize: 'large' }}>
                {(() => {
                  if (topupStatus === 'complete') return 'เติมเครดิตสำเร็จ';
                  if (topupStatus === 'error') return 'เติมเครดิตไม่สำเร็จ';
                  return 'กำลังดำเนินการ...';
                })()}
              </Typography>
              <Typography variant="caption">
                {(() => {
                  if (topupStatus === 'complete') return 'เครดิตของคุณถูกเพิ่มไปยังกระเป๋าเรียบร้อย';
                  if (topupStatus === 'error') return 'มีข้อผิดพลาด โปรดลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่';
                  return 'เมื่อยืนยันการชำระเงินเรียบร้อย คุณจะกลับสู่หน้าหลักอัตโนมัติ';
                })()}
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  </Container>
);
